(() => {
  if (window.__ifySiteReady) return;
  window.__ifySiteReady = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = document.querySelectorAll('.ify-reveal');

  if (!reduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    reveal.forEach((el) => observer.observe(el));
  } else {
    reveal.forEach((el) => el.classList.add('is-visible'));
  }

  if (!reduced) {
    document.querySelectorAll('[data-ify-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        card.style.setProperty('--ify-ry', `${x * 6}deg`);
        card.style.setProperty('--ify-rx', `${y * -6}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--ify-ry', '0deg');
        card.style.setProperty('--ify-rx', '0deg');
      });
    });
  }
})();
